import * as React from 'react';
import {
	AutocompleteInput,
	Create,
	CreateProps,
	DateInput,
	NumberInput,
	ReferenceInput,
	SimpleForm,
	TextInput
} from 'react-admin';
import { UploadImage } from '../components/UploadImage';

export const MarathonCreate = (props: CreateProps): React.ReactElement => {
	return (
		<Create {...props}>
			<SimpleForm>
				<UploadImage step={1} source="featuredImageUrl" label="FEATURED_IMAGE_URL"/>
				<TextInput step={1} source="name" label="NAME"/>
				<TextInput multiline step={1} source="agenda" label="AGENDA"/>
				<NumberInput step={1} source="duration" label="DURATION"/>
				<DateInput step={1} source="date" label="DATE"/>
				<TextInput type="url" step={1} source="groupLink" label="GROUP_LINK"/>
				<ReferenceInput
					step={1}
					label="COACH"
					source="coachId" reference="clients"
					alwaysOn
				>
					<AutocompleteInput optionText="fullName"/>
				</ReferenceInput>
			</SimpleForm>
		</Create>
	);
};
